// import React from 'react'
// import { Link, useLocation } from 'react-router-dom'
// import bicepsSvgBlue from '../../../../../assets/biceps-blue.svg';
// import bicepsSvgGray from '../../../../../assets/biceps-gray.svg'
// import { u } from 'framer-motion/client';

// export const ListComponent = ({
//     index,
//     functionBtn,
//     icon,
//     title,
//     url,
//     defaultSelected
// }) => {

//     const location = useLocation()

//     return (
//         <li className="oc-li-menu ">

//             <Link
//                 className="oc-a-management"
//                 to={`/${url}`}
//                 onClick={functionBtn}>
//                 {index === 3 ?
//                     <>
//                         <img
//                             src={location.pathname === `/${url}` ? `${bicepsSvgBlue}` : `${bicepsSvgGray}`}
//                             className="biceps-svg" alt='biceps' />
//                         <p className={`oc-p-management ${location.pathname === `/${url}` ? 'currentPage' : defaultSelected ? 'currentPage' : ''}`}>
//                             {title}
//                         </p>
//                     </>
//                     :
//                     <>
//                         <span
//                             className={`material-symbols-outlined notranslate ${location.pathname === `/${url}` ? 'currentPage' : defaultSelected ? 'currentPage' : ''}`}
//                             aria-hidden="true"
//                             >
//                             {icon}
//                         </span>
//                         <p className={`oc-p-management ${location.pathname === `/${url}` ? 'currentPage' : defaultSelected ? 'currentPage' : ''}`}>
//                             {title}
//                         </p>
//                     </>
//                 }
//             </Link>
//         </li>
//     )
// }


import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import bicepsSvgBlue from '../../../../../assets/biceps-blue.svg';
import bicepsSvgGray from '../../../../../assets/biceps-gray.svg'
import { u } from 'framer-motion/client';

export const ListComponent = ({
    index,
    functionBtn,
    icon,
    title,
    url,
    isActive
}) => {

    const location = useLocation()

    return (
        <li className="oc-li-menu ">

            <Link
                className="oc-a-management"
                to={`/${url}`}
                onClick={functionBtn}>
                {index === 3 ?
                    <>
                        <img
                            src={location.pathname === `/${url}` ? `${bicepsSvgBlue}` : `${bicepsSvgGray}`}
                            className="biceps-svg" alt='biceps' />
                        <p className={`oc-p-management ${isActive ? 'currentPage' : ''}`}>
                            {title}
                        </p>
                    </>
                    :
                    <>
                        <span
                            className={`material-symbols-outlined notranslate ${isActive ? 'currentPage' : ''}`}
                            aria-hidden="true" role="none"
                            >
                            {icon}
                        </span>
                        <p className={`oc-p-management ${isActive ? 'currentPage' : ''}`}>
                            {title}
                        </p>
                    </>
                }
            </Link>
        </li>
    )
}
